export const EVENT_APP_NAVIGATE = 'navigate';
export const APP_GENERIC_ERROR = 'error';

export const OPEN_FEEDBACK_MODAL = 'open_feedback_modal';